import { c as _c } from "react/compiler-runtime";
import arrowDown from '@images/svg/index/arrow-down.svg';
import { useOnClickOutside } from '@lib/tools/hooks/useOnClickOutside';
import cn from 'classnames';
import { useRef } from 'react';
import Svg from 'react-inlinesvg';
import styles from './Dropdown.module.scss';
export const DropDownCalc = t0 => {
  const $ = _c(24);
  const {
    label,
    list,
    onSelect,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const ref = useRef();
  let t2;
  if ($[0] !== list) {
    t2 = list.find(_temp) || list[0];
    $[0] = list;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const activeProgram = t2;
  const onClose = () => {
    ref.current?.removeAttribute("open");
  };
  const onClick = (event, item) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    onSelect?.(event, item);
    onClose();
  };
  let t3;
  if ($[2] !== disabled) {
    t3 = event_0 => {
      if (disabled) {
        event_0.preventDefault();
        event_0.stopPropagation();
      }
    };
    $[2] = disabled;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onDisabledSummary = t3;
  useOnClickOutside(ref, onClose);
  let t4;
  if ($[4] !== label) {
    t4 = label && <p>{label}</p>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = disabled && styles.disabled;
  let t6;
  if ($[6] !== t5) {
    t6 = cn(styles.calc_dropdown, t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== activeProgram.label) {
    t7 = <span>{activeProgram.label}</span>;
    $[8] = activeProgram.label;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Svg src={arrowDown.src} fill="#636363" className={styles.calc_svgArrows} />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== onDisabledSummary || $[12] !== t7) {
    t9 = <summary className={styles.calc_chosedProgram} onClick={onDisabledSummary}>{t7}{t8}</summary>;
    $[11] = onDisabledSummary;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = styles;
  const t11 = list.map(p_0 => <div key={p_0.value} className={cn(styles.calc_programs_item, p_0.value === activeProgram.value ? styles.active : "")} onClick={e => onClick(e, p_0)}>{p_0.label}</div>);
  let t12;
  if ($[14] !== t10.calc_programs || $[15] !== t11) {
    t12 = <div className={t10.calc_programs}>{t11}</div>;
    $[14] = t10.calc_programs;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t6 || $[19] !== t9) {
    t13 = <details className={t6} ref={ref}>{t9}{t12}</details>;
    $[17] = t12;
    $[18] = t6;
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t4) {
    t14 = <>{t4}{t13}</>;
    $[21] = t13;
    $[22] = t4;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};
function _temp(p) {
  return p.active;
}